export default {
  method_unavailable: "Ce mode de paiement n'est pas disponible pour le moment. Choisissez-en un autre.",
  payment_option_unavailable:
    "Cette option de paiement n'est pas disponible pour le moment. Choisissez un autre moyen de paiement.",
  online_payment_unavailable: "Le paiement en ligne n'est pas disponible pour le moment. Réessayez dans un instant.",
  retry_payment_methods: 'Réessayer',
  payment_not_ready: 'Votre paiement est encore en cours de préparation. Réessayez dans un instant.',
  wallet_total_changed: 'Le total pour ce moyen de paiement a changé. Vérifiez-le et appuyez à nouveau sur le bouton.',
  wallet_tap_above: 'Appuyez sur le bouton {{method}} ci-dessus pour payer, ou choisissez un autre moyen de paiement.',
  wallet_pay_above: 'Utilisez le bouton {{method}} ci-dessus',
  element_incomplete: 'Complétez vos informations de paiement pour continuer.',
  element_incomplete_card: 'Vérifiez les informations de votre carte et réessayez.',
  element_incomplete_bank: 'Choisissez votre banque pour continuer.',
  element_incomplete_sepa_debit: 'Vérifiez votre IBAN et les informations du titulaire du compte pour continuer.',
};
